import React from 'react'
import PropTypes from 'prop-types'
import style from '../liveBlogCard/style.module.scss'

function LiveBlogTimeLine({ data }) {
  function handleScrollView(elementData) {
    const dataId = `${elementData?._id}_${elementData?.iEventId}_${elementData?.sEventId}`
    const element = document.getElementById(dataId)
    element.scrollIntoView({ behavior: 'smooth' })
  }
  return (
    <>
      <h4>Time Line</h4>
      {data?.aLiveArticleList?.length > 0 &&
        data?.aLiveArticleList?.map((d, i) => {
          return (
            <div key={i} className={`${style.liveBox} ps-3 ps-md-4 position-relative`} id={`${d?._id}_${d?.iEventId}_${d?.sEventId}`}>
              <span className={style.timeLine} onClick={() => handleScrollView(d)}>
                {d?.sTitle}
              </span>
            </div>
          )
        })}
    </>
  )
}

LiveBlogTimeLine.propTypes = {
  data: PropTypes.object
}

export default LiveBlogTimeLine
